/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _HeaderGroup = _interopRequireDefault(require("./Header/HeaderGroup"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var extraChildrenProps = {
  onUnmount: null,
  ref: null,
  dragging: true
};
var DragHeaderGroup = function (_React$Component) {
  (0, _inherits2.default)(DragHeaderGroup, _React$Component);
  var _super = _createSuper(DragHeaderGroup);
  function DragHeaderGroup(_props) {
    var _this;
    (0, _classCallCheck2.default)(this, DragHeaderGroup);
    _this = _super.call(this, _props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getProps", function () {
      return _this.state.props || _this.props;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setProps", function (props) {
      _this.setState({
        props: props
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setDragging", function (visible, callback) {
      if (!visible) {
        _this.top = undefined;
        _this.left = undefined;
        _this.right = undefined;
        _this.width = undefined;
        _this.height = undefined;
      }
      _this.setState({
        visible: visible
      }, function () {
        if (_this.headerGroup && visible) {
          _this.headerGroup.setDragging(visible, callback);
          if (_this.top !== undefined) {
            _this.headerGroup.setTop(_this.top);
          }
          if (_this.left !== undefined) {
            _this.headerGroup.setLeft(_this.left);
          }
          if (_this.right !== undefined) {
            _this.headerGroup.setRight(_this.right);
          }
          if (_this.height !== undefined) {
            _this.headerGroup.setHeight(_this.height);
          }
          if (_this.width !== undefined) {
            _this.headerGroup.setWidth(_this.width);
          }
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setHeight", function (height) {
      _this.height = height;
      if (_this.headerGroup && _this.state.visible) {
        _this.headerGroup.setHeight(height);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setWidth", function (width) {
      _this.width = width;
      if (_this.headerGroup && _this.state.visible) {
        _this.headerGroup.setWidth(width);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setTop", function (top) {
      _this.top = top;
      if (_this.headerGroup && _this.state.visible) {
        _this.headerGroup.setTop(top);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setLeft", function (left) {
      _this.left = left;
      if (_this.headerGroup && _this.state.visible) {
        _this.headerGroup.setLeft(left);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setRight", function (right) {
      _this.right = right;
      if (_this.headerGroup && _this.state.visible) {
        _this.headerGroup.setRight(right);
      }
    });
    _this.refHeaderGroup = function (group) {
      _this.headerGroup = group;
    };
    _this.state = {
      visible: false
    };
    return _this;
  }
  (0, _createClass2.default)(DragHeaderGroup, [{
    key: "render",
    value: function render() {
      if (this.state.visible) {
        var props = this.getProps();
        var className = props.className ? "".concat(props.className, " InovuaReactDataGrid__drag-proxy") : 'InovuaReactDataGrid__drag-proxy';
        return _react.default.createElement(_HeaderGroup.default, _objectSpread(_objectSpread({}, props), {}, {
          dragging: true,
          extraChildrenProps: extraChildrenProps,
          className: className,
          ref: this.refHeaderGroup
        }));
      }
      return null;
    }
  }]);
  return DragHeaderGroup;
}(_react.default.Component);
exports.default = DragHeaderGroup;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/Layout/ColumnLayout/HeaderLayout/DragHeaderGroup.js
// module id = 561
// module chunks = 0